export const usuarioLogueado = () => {
  const z = localStorage.getItem('usuarioLogueado');
  return JSON.parse(z);
};

export const setUsuarioLogueado = data => {
  localStorage.setItem('SHERPA_AUTH_JWT_ID', data.idToken);
  if (!data.foto) data.foto = '../images/default_user.jpeg';
  localStorage.setItem('usuarioLogueado', JSON.stringify(data));
};
